import i18nFactory from '@yandex-int/i18n';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../../actions';
import { openImageSmartCenterEditor } from '../../../actions/imageSmartCenterEditor';
import { ButtonDecorator } from '../../../components/ButtonDecorator/ButtonDecorator';
import { HoverTooltipWrapper } from '../../../components/HoverTooltipWrapper/HoverTooltipWrapper';
import { TestBem } from '../../../service/TestBem';
import { BannerId } from '../../../typings/banners';
import { getEditedBannerWithImage } from '../../../typings/bannersEditState';
import { ImageSmartCenterEditorData } from '../../../typings/imageSmartCenterEditor';
import { State } from '../../../typings/state';
import { ImageSmartCenterEditorContainer } from '../ImageSmartCenterEditorContainer';

import * as keyset from './ImageSmartCenterEditorSwitcherContainer.i18n';

interface OwnProps {
    bannerId: BannerId;
}

interface StateProps {
    noImage: boolean;
    noFormats: boolean;
    imageSmartCenterData?: ImageSmartCenterEditorData;
}

interface DispatchProps {
    onClick: () => void;
}

type ImageSmartCenterEditorSwitcherProps = StateProps & DispatchProps & OwnProps;

const i18n = i18nFactory(keyset);

const BLOCK = 'image-smart-center-editor-switcher';

class ImageSmartCenterEditorSwitcher extends React.Component<ImageSmartCenterEditorSwitcherProps> {
    render() {
        const { noFormats, noImage, imageSmartCenterData } = this.props;
        const button = (
            <ButtonDecorator
                cls={TestBem.cls(BLOCK)}
                theme={'normal'}
                size={'n'}
                onClick={this.onClick}
                text={i18n('edit-smart-centers')}
                disabled={noFormats || noImage}
            />
        );

        return (
            <>
                {noFormats || noImage ? (
                    <HoverTooltipWrapper
                        to={'right'}
                        tooltipText={noImage ? i18n('no-image-message') : i18n('no-formats-message')}
                    >
                        {button}
                    </HoverTooltipWrapper>
                ) : (
                    button
                )}
                {imageSmartCenterData && <ImageSmartCenterEditorContainer />}
            </>
        );
    }

    private onClick = () => {
        this.props.onClick();
    };
}

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const banner = getEditedBannerWithImage(state.editBanners.banners[ownProps.bannerId]);
    const bannerImage = state.imageEditor[ownProps.bannerId].image;
    let noImage = false;
    let noFormats = false;
    if (!banner) {
        noImage = true;
    } else {
        noImage = !bannerImage.data;
        noFormats = !bannerImage.data || !bannerImage.data.formats || !bannerImage.data.formats.length;
    }

    return {
        noImage,
        noFormats,
        imageSmartCenterData: state.imageSmartCenterEditor.data
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    return {
        onClick: () => {
            dispatch(openImageSmartCenterEditor(ownProps.bannerId));
        }
    };
};

export const ImageSmartCenterEditorSwitcherContainer = connect<StateProps, DispatchProps, OwnProps, State>(
    mapStateToProps,
    mapDispatchToProps
)(ImageSmartCenterEditorSwitcher);
